import React from "react";
import Loading from "../../../components/Loading";
import Modal from "../../../components/Modal";
import CustomSelect from "../../../components/CustomSelect";
import CustomInput from "../../../components/CustomInput";

const OrderDetailModal = ({
  isOpen,
  onClose,
  selectedOrder,
  detailLoading,
  editData,
  setEditData,
  invoiceFile,
  setInvoiceFile,
  originalInvoice,
  onUpdate,
  onSelectInvoiceFile,
  formatCurrency,
}) => {
  const statusOptions = [
    { label: "Chưa thanh toán", value: "Chưa thanh toán" },
    { label: "Đã thanh toán", value: "Đã thanh toán" },
    { label: "Đã hủy", value: "Đã hủy" },
  ];

  const handleClose = () => {
    setInvoiceFile(null);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Chi tiết đơn hàng"
      maxWidth="600px"
      showCancelButton
      cancelButtonText="Hủy bỏ"
      primaryButtonText={!detailLoading && selectedOrder ? "Lưu lại" : null}
      primaryButtonOnClick={onUpdate}
      primaryButtonVariant="primary"
    >
      {detailLoading ? (
        <div className="flex items-center justify-center py-12">
          <Loading size="md" text="Đang tải chi tiết đơn hàng..." />
        </div>
      ) : selectedOrder ? (
        <div className="px-5 py-4 space-y-6">
          <div className="bg-[#F9F9F9] rounded-[12px] p-3">
            <h3 className="text-base font-semibold text-gray-900 mb-3">
              Thông tin đơn hàng
            </h3>

            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-sm text-gray-600 mb-2">
                  Mã đơn hàng
                </label>
                <p className="text-base font-semibold text-gray-900">
                  {selectedOrder.orderCode}
                </p>
              </div>

              <div>
                <label className="block text-sm text-gray-600 mb-2">
                  Tổng tiền
                </label>
                <p className="text-base font-semibold text-blue-600">
                  {formatCurrency(selectedOrder.totalAmount)}
                </p>
              </div>

              <div className="max-w-[180px]">
                <label className="block text-sm text-gray-600 mb-2">
                  Trạng thái
                </label>
                <CustomSelect
                  options={statusOptions}
                  value={statusOptions.find(
                    (opt) => opt.value === editData.status,
                  )}
                  onChange={(option) =>
                    setEditData({ ...editData, status: option.value })
                  }
                  placeholder="Chọn trạng thái"
                  height="42px"
                  required
                />
              </div>
            </div>
          </div>

          {/* ===== THÔNG TIN KHÁCH HÀNG ===== */}
          <div className="bg-[#F9F9F9] rounded-[12px] p-3">
            <h3 className="text-base font-semibold text-gray-900 mb-3">
              Thông tin khách hàng
            </h3>

            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-sm text-gray-600 mb-2">Tên</label>
                <p className="text-base text-gray-900">
                  {selectedOrder?.customer?.name}
                </p>
              </div>

              <div>
                <label className="block text-sm text-gray-600 mb-2">
                  Email
                </label>
                <p className="text-base text-gray-900">
                  {selectedOrder?.customer?.email}
                </p>
              </div>

              <div className="col-span-2">
                <label className="block text-sm text-gray-600 mb-2">
                  Nhãn hiệu
                </label>
                <p className="text-base text-gray-900">
                  {selectedOrder?.profile?.brand}
                </p>
              </div>
            </div>
          </div>

          {/* ===== THÔNG TIN BỔ SUNG ===== */}
          <div className="bg-[#F9F9F9] rounded-[12px] p-3 space-y-4">
            <h3 className="text-base font-semibold text-gray-900">
              Thông tin bổ sung
            </h3>

            {/* HÓA ĐƠN */}
            <div>
              <label className="block text-sm text-gray-600 mb-2">
                Link hoá đơn
              </label>

              {/* ĐÃ CÓ HÓA ĐƠN */}
              {!invoiceFile && originalInvoice && (
                <div className="bg-[#F3F3F3] border rounded-[8px] p-3">
                  <a
                    href={originalInvoice}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 font-medium hover:underline"
                  >
                    Xem hoá đơn
                  </a>
                </div>
              )}

              {/* CHƯA CÓ */}
              {!originalInvoice && !invoiceFile && (
                <div className="bg-[#F3F3F3] border rounded-[8px] p-2">
                  <input
                    type="file"
                    accept=".pdf,.png,.jpg,.jpeg"
                    onChange={(e) => onSelectInvoiceFile(e.target.files[0])}
                    className="hidden"
                    id="invoice-upload"
                  />
                  <label
                    htmlFor="invoice-upload"
                    className="inline-flex items-center gap-2 px-3 py-[6px] bg-gray-200 rounded-[8px] cursor-pointer hover:bg-gray-300"
                  >
                    Chọn tệp
                  </label>
                  <span className="ml-2 text-sm text-gray-400">
                    Chưa có tệp nào
                  </span>
                </div>
              )}

              {/* ĐÃ CHỌN FILE MỚI */}
              {invoiceFile && (
                <div className="flex items-center gap-3 bg-[#F3F3F3] border rounded-[10px] px-3 py-2">
                  <input
                    type="file"
                    accept=".pdf,.png,.jpg,.jpeg"
                    id="invoice-upload"
                    className="hidden"
                    onChange={(e) => onSelectInvoiceFile(e.target.files[0])}
                  />
                  <label
                    htmlFor="invoice-upload"
                    className="bg-gray-200 px-3 py-1.5 rounded-[8px] cursor-pointer hover:bg-gray-300"
                  >
                    Chọn tệp
                  </label>
                  <span className="text-sm truncate max-w-[260px]">
                    {invoiceFile.name}
                  </span>
                </div>
              )}
            </div>

            {/* GHI CHÚ */}
            <div>
              <label className="block text-sm text-gray-600 mb-2">
                Ghi chú
              </label>
              <CustomInput
                isTextarea
                rows={3}
                value={editData.note}
                onChange={(value) => setEditData({ ...editData, note: value })}
                placeholder="Nhập ghi chú"
              />
            </div>
          </div>
        </div>
      ) : null}
    </Modal>
  );
};

export default OrderDetailModal;
